import { Component, Input } from '@angular/core';
// BILL-3055: SafeHtml + MarkdownRenderService habilitan el renderizado seguro de Markdown
// para los mensajes del asistente (ver toSanitizedHtml en el servicio, sanitizado con DOMPurify).
import { SafeHtml } from '@angular/platform-browser';

import { ChatMessage } from '../../models/chat.models';
import { MarkdownRenderService } from '../../services/markdown-render.service';

@Component({
  selector: 'app-chat-message',
  standalone: true,
  imports: [],
  templateUrl: './chat-message.component.html',
  styleUrls: ['./chat-message.component.scss']
})
export class ChatMessageComponent {
  @Input({ required: true }) message!: ChatMessage;

  // BILL-3055: memoiza — sin esto, toSafeHtml corria en cada ciclo de CD y Angular reescribia el DOM entero en cada tick.
  private cachedText: string | undefined;
  private cachedSafeHtml: SafeHtml = '';

  // BILL-3055: inyecta el servicio de renderizado de Markdown, usado solo para mensajes del asistente.
  constructor(private readonly markdownRenderService: MarkdownRenderService) {}

  get formattedTime(): string {
    const date = new Date(this.message.createdAt);
    return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  }

  // BILL-3055: expone el texto del asistente como HTML sanitizado interpretando Markdown
  // (negrita, listas, enlaces, etc.); los mensajes de usuario nunca pasan por aqui.
  // BILL-3055: memoiza — sin esto, toSafeHtml corria en cada ciclo de CD y Angular reescribia el DOM entero en cada tick.
  get renderedText(): SafeHtml {
    if (this.message.text !== this.cachedText) {
      this.cachedText = this.message.text;
      this.cachedSafeHtml = this.markdownRenderService.toSafeHtml(this.message.text);
    }
    return this.cachedSafeHtml;
  }
}
